import {
  CancelPaymentRequest,
  ConfirmPaymentRequest,
  CreatePaymentIntentRequest,
  Payment,
  PaymentIntentResponse,
  RefundPaymentRequest,
} from '../types/payment';
import { BaseApiService } from './baseApiService';

/**
 * Service for payment operations
 */
class PaymentService extends BaseApiService {
  async createPaymentIntent(
    data: CreatePaymentIntentRequest
  ): Promise<PaymentIntentResponse> {
    await this.ensureInitialized();
    const response = await this.api.post('/payment/create-intent', data);
    return response.data;
  }

  async confirmPayment(
    data: ConfirmPaymentRequest
  ): Promise<{ success: boolean }> {
    await this.ensureInitialized();
    const response = await this.api.post('/payment/confirm', data);
    return response.data;
  }

  async getPayment(
    paymentIntentId: string,
    provider: string
  ): Promise<Payment> {
    await this.ensureInitialized();
    const response = await this.api.get(
      `/payment/${paymentIntentId}?provider=${provider}`
    );
    return response.data;
  }

  async getOrderPayments(orderId: number): Promise<Payment[]> {
    await this.ensureInitialized();
    const response = await this.api.get(`/payment/order/${orderId}`);
    return response.data;
  }

  async refundPayment(
    data: RefundPaymentRequest
  ): Promise<{ success: boolean }> {
    await this.ensureInitialized();
    const response = await this.api.post('/payment/refund', data);
    return response.data;
  }

  async cancelPayment(
    data: CancelPaymentRequest
  ): Promise<{ success: boolean }> {
    await this.ensureInitialized();
    const response = await this.api.post('/payment/cancel', data);
    return response.data;
  }
}

export const paymentService = new PaymentService();
export default paymentService;
